import { ROUTES } from '@/constants/routes';

const PRELAUNCH_ALLOWED_HOSTS = new Set([
  'dev.agentous.ai',
  'localhost',
  '127.0.0.1',
  '[::1]',
]);

const normalizePathname = (pathname: string): string => {
  if (!pathname) return '/';
  return pathname.endsWith('/') && pathname !== '/'
    ? pathname.slice(0, -1)
    : pathname;
};

export const isPrelaunchAccessAllowedHost = (hostname: string): boolean => {
  const normalizedHost = hostname.toLowerCase();

  if (PRELAUNCH_ALLOWED_HOSTS.has(normalizedHost)) {
    return true;
  }

  return normalizedHost.endsWith('.localhost');
};

export const isPrelaunchRoute = (pathname: string): boolean => {
  const normalizedPath = normalizePathname(pathname);
  const isPolicyBooksRoute =
    normalizedPath === ROUTES.DASHBOARD_POLICY_BOOKS ||
    normalizedPath.startsWith(`${ROUTES.DASHBOARD_POLICY_BOOKS}/`);

  return (
    normalizedPath === ROUTES.PRICING ||
    normalizedPath === ROUTES.PRICING_SUITES ||
    normalizedPath === ROUTES.PRICING_AGENTS ||
    normalizedPath === ROUTES.DASHBOARD_SETTINGS_BILLING ||
    isPolicyBooksRoute
  );
};

export const canAccessPrelaunchRoutes = (): boolean => {
  if (typeof window === 'undefined') {
    return true;
  }

  return isPrelaunchAccessAllowedHost(window.location.hostname);
};

export const isRouteAccessibleInCurrentEnvironment = (
  pathname: string
): boolean => {
  if (!isPrelaunchRoute(pathname)) {
    return true;
  }

  return canAccessPrelaunchRoutes();
};
